'use client';
import { Box } from '@mui/material';
import Typography from '../typography/typography.component';
import { useTranslation } from '@/hook';
import Tooltip, { tooltipClasses, TooltipProps } from '@mui/material/Tooltip';
import { styled } from '@mui/material/styles';

const SoldBadge = () => {
  const { t } = useTranslation();

  const soldBadge = {
    display: 'flex',
    gap: '4px',
    backgroundColor: '#E6FBF2',
    borderRadius: '8px',
    color: '#00673E',
    paddingBlock: '2px',
    paddingInline: '10px',
    alignItems: 'center',
    width: 'fit-content',
    zIndex: 1,
  };

  const toolTip = {
    display: 'block',
    marginLeft: 'auto',
  };

  const ReservedTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.white,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: '#344054',
      border: '1px solid #EAECF0',
    },
  }));

  return (
    <>
      {/* <ReservedTooltip
        title={
          <Typography variant="body2Medium">{t('reservedBadgeTooltipDescription')}</Typography>
        }
        sx={toolTip}
      > */}
      <Box sx={soldBadge}>
        <Typography variant="body2Medium">{t('soldPage.soldFlag')}</Typography>
      </Box>
      {/* </ReservedTooltip> */}
    </>
  );
};

export default SoldBadge;
